App.namespace.wrap('views.room.truncate', () => {
  const ImageCarousel = App.es6.shared.lory_carousel;

  $('.js-truncate-description')
    .not('.js-truncate-description-processed')
    .each(function truncate() {
      const height = parseInt($(this).attr('data-height'), 10);
      $(this).collapseContent(height);
      $(this).addClass('js-truncate-description-processed');
    });

  //------------------------------------------------------------------------------------------------------------------

  /**
   * Truncate room features after certain amount of feature elements.
   * @type {*|jQuery|HTMLElement}
   */
  const $featureContainer = $('.js-truncate');
  const defaultTruncateNumber = 6;
  const isDesktop = window.innerWidth >= 768;
  const defaultLabel = 'Show more';

  const OTHER_ROOM_CAROUSEL = '.js-other-room-carousel';

  const expandSection = function () {
    const hasShowLessFeature = $featureContainer.hasClass('js-truncate-show-less');
    const $container = $(this).parent().find('.js-truncate');
    const $hiddenElements = $container.find('.hidden');
    const $carouselsToInit = $hiddenElements.find(OTHER_ROOM_CAROUSEL);
    if (hasShowLessFeature) {
      const showLessButton = $container.parent().find('.btn-truncate-less');
      showLessButton.removeClass('hidden');
    }
    ImageCarousel($carouselsToInit);

    $hiddenElements.removeClass('hidden');
    $(this).parent().find('.js-truncate').addClass('expanded');
    if (hasShowLessFeature) {
      $(this).addClass('hidden');
    }
    else {
      $(this).remove();
    }

    const trackSection = $container.data('track-section');
    if (trackSection) {
      $.publish('room_page_interaction', {
        section: trackSection,
        element: 'show_more',
        interaction: 'click',
      });
    }

    window.App.views.shared.fixTooltips({ repaint: 1, container: $container.get(0) });
  };

  const initTruncate = function ($truncatedSection, truncateButtonLabel, hasShowLessFeature) {
    const $moreButton = $(`<button class='btn btn-truncate-more'>${truncateButtonLabel}</button>`);
    if (hasShowLessFeature) {
      const $lessButton = $('<button class="btn btn-truncate-less hidden">Show less</button>');
      $lessButton.click(() => {
        $truncatedSection.addClass('hidden');
        $moreButton.removeClass('hidden');
        $lessButton.addClass('hidden');
      });
      $(this).parent().append($lessButton);
    }

    $truncatedSection.addClass('hidden');
    $(this).parent().append($moreButton);

    const $carouselElements = $(this).children().not('.hidden').find(OTHER_ROOM_CAROUSEL);
    ImageCarousel($carouselElements, true);

    $moreButton.click(expandSection);
  };

  $.each($featureContainer, function () {
    const $this = $(this);
    const hasShowLessFeature = $this.hasClass('js-truncate-show-less');
    const $features = $this.children();
    const $featuresTotal = $features.length;
    const truncateNumberDesktop = $this.attr('data-visible-count') ? $this.attr('data-visible-count') : defaultTruncateNumber;
    const truncateNumberMobile = $this.attr('data-visible-count-mobile') ? $this.attr('data-visible-count-mobile') : defaultTruncateNumber;
    const truncateButtonLabel = $this.attr('data-more-button-label') ? `Show all ${$featuresTotal} ${$this.attr('data-more-button-label')}` : defaultLabel;
    const $truncatedSectionDesktop = $this.children().slice(truncateNumberDesktop, $featuresTotal);
    const $truncatedSectionMobile = $this.children().slice(truncateNumberMobile, $featuresTotal);

    if (isDesktop && $featuresTotal > truncateNumberDesktop) {
      initTruncate.call(this, $truncatedSectionDesktop, truncateButtonLabel, hasShowLessFeature);
    } else if (!isDesktop && $featuresTotal > truncateNumberMobile) {
      initTruncate.call(this, $truncatedSectionMobile, truncateButtonLabel, hasShowLessFeature);
    } else {
      const $carouselElements = $(this).find(OTHER_ROOM_CAROUSEL);
      // Not enough features to enable truncate
      if ($carouselElements.length) {
        ImageCarousel($carouselElements, true);
      }
    }
  });

  $('.js-pricing-description').collapseContent(70);
});
